<section class="expand-event-wrap" [attr.data-sportId]="expandedEvent.sportId" id="expandEventWrap"
[ngClass]="{'prematch': !expandedEvent.isLive, 'versionV2': viewConfigurations.useMobileViewWithTopMenu}" >
  <div class="event-details box mb-3" id="bottomWrap">
    <div class="close-back" (click)="hideDetails()">
      <i class="icon icon-cross icon-sm"></i>
    </div>
    <!-- <div class="competition-logo reg-1"></div> -->
    <div class="match-info">
      <div class="competition-name">
        <div class="icon-chart" *ngIf="viewConfigurations.showH2HwidgetOnDetail && expandedEvent.betRadarEventId" (click)="matchPreviewWidget(); $event.stopPropagation();">
          <span class="sporticon icon-sm sporticon-chart"></span>
        </div>
        {{expandedEvent.regionName}} {{expandedEvent.competitionName}}
      </div>
      <div class="result-wrap" *ngIf="expandedEvent.isLive && showShortResultAndResultOnExpandLive; else showTime">
        <div class="home-result">
          <div class="server" *ngIf="expandedEvent.result?.server == 1"></div>
          <span class="current-score" *ngIf="expandedEvent.result">{{expandedEvent.result.homeScore}}</span>
          <ng-container *ngIf="expandedEvent.result">
            <span *ngFor="let homeSetScore of expandedEvent.result.homeSetScore">{{homeSetScore}}</span>
            <span class="gem-score" *ngIf="expandedEvent.sportId === 3 && !viewConfigurations.showWidgetsOnSite">{{expandedEvent.result.homeGameScore}}</span>
          </ng-container>
        </div>
        <div class="away-result">
          <div class="server" *ngIf="expandedEvent.result?.server == 2"></div>
          <span class="current-score" *ngIf="expandedEvent.result">{{expandedEvent.result.awayScore}}</span>
          <ng-container *ngIf="expandedEvent.result">
            <span *ngFor="let awaySetScore of expandedEvent.result.awaySetScore">{{awaySetScore}}</span>
            <span class="gem-score" *ngIf="expandedEvent.sportId === 3 && !viewConfigurations.showWidgetsOnSite">{{expandedEvent.result.awayGameScore}}</span>
          </ng-container>
        </div>
        <!-- <div class="stoppage-time">+{{expandedEvent.result.stoppageTimeAnnounced}}</div> -->
      </div>
      <ng-container *ngIf="expandedEvent.isLive && (!expandedEvent.betRadarEventId || expandedEvent.result?.stoppageTimeAnnounced)">
        <div class="stoppage-time" [class.move-down]="!expandedEvent.betRadarEventId">
          <ng-container *ngIf="!expandedEvent?.betRadarEventId">{{expandedEvent.result?.matchTime}} </ng-container>
          <ng-container *ngIf="expandedEvent.result?.stoppageTimeAnnounced">(+{{expandedEvent.result?.stoppageTimeAnnounced}})</ng-container>
        </div>
      </ng-container>
      <ng-template #showTime>
        <div class="time-info">
          <i class="icon icon-calendar-full"></i> {{expandedEvent.dateTime | date:"dd LLL": "" : languageCulture}}
          <i class="icon icon-clock"></i> {{expandedEvent.dateTime | date: "HH:mm"}}
        </div>
      </ng-template>
    </div>
    <div class="streaming-widget-wrap" *ngIf="expandedEvent.isLive && expandedEvent.betRadarEventId && viewConfigurations.showWidgetsOnSite; else prematch">
      <app-streaming-wrap [class.hide]="widgetErrorMessage && viewConfigurations.hideWidgetIfNotLicensed" [isWidgetFullSize]="true" *ngIf="expandedEvent.isLive"></app-streaming-wrap>
      <ng-container *ngIf="!(widgetErrorMessage && viewConfigurations.hideWidgetIfNotLicensed) else prematch"></ng-container>
      <!-- <app-streaming-widget [isFullSize]="true" [betRadarEventId]="expandedEvent.betRadarEventId"></app-streaming-widget>

      <div class="live-streaming-wrap" *ngIf="expandedEvent.liveStreamId">
        <div class="streaming-button" (click)="showStreaming()">Watch live stream</div>
        <app-streaming *ngIf="isStreamingShow" [url]="expandedEvent.streamUrl"></app-streaming>
      </div> -->
    </div>

    <ng-template #prematch>
      <div class="teams-info">
        <div class="team" [class.f-row]="viewConfigurations.showH2HwidgetOnDetail">
          <!-- <div class="badge-wrap">
              <div class="badge">
                  <span class="event-id-12"></span>
              </div>
          </div> -->
          <div class="icon-chart" *ngIf="viewConfigurations.showH2HwidgetOnDetail && expandedEvent.betRadarEventId" (click)="headToHeadWidget(); $event.stopPropagation();">
            <span class="sporticon icon-sm sporticon-chart"></span>
          </div>
          <div>
            <div class="short-name h6">{{expandedEvent.homeTeamShort}}</div>
            <div class="name">{{expandedEvent.homeTeam}}</div>
          </div>
        </div>

        <div class="date-score" *ngIf="expandedEvent.awayTeam">
          <!-- <div class="date">
              <span>{{expandedEvent.dateTime | date: "dd MMM yyyy"}}</span>
              <span class="time">{{expandedEvent.dateTime | date: "HH:mm"}}</span>
          </div> -->
          <div class="score">
            <ng-container *ngIf="expandedEvent.result">{{expandedEvent.result.score}}</ng-container>
            <ng-container *ngIf="!expandedEvent.result">- : -</ng-container>
          </div>
        </div>

        <div class="team">
          <!-- <div class="badge-wrap">
              <div class="badge">
                  <span class="event-id-30"></span>
              </div>
          </div> -->
          <div class="short-name h6">{{expandedEvent.awayTeamShort}}</div>
          <div class="name">{{expandedEvent.awayTeam}}</div>
        </div>
      </div>

      <div class="bet-menu-wrap" *ngIf="!expandedEvent.isLive">
        <ng-container *ngFor="let betTypeGroup of betTypeGroups">
          <div class="bet-menu-item" *ngIf="betTypeGroup.isOnline" [class.active]="betTypeGroup.isSelected"  (click)="selectGroup(betTypeGroup)">{{betTypeGroup.name | lowercase}}</div>
        </ng-container>
      </div>

    </ng-template>
  </div>

  <section class="bet-types-main-wrap box">

    <div class="bet-menu-wrap" *ngIf="expandedEvent.isLive" [class.no-border]="!isAnyGroupActive || !expandedEvent.isPlayable || !expandedEvent.isInOffer">
      <section class="loader-wrap" *ngIf="!isAnyGroupActive || !expandedEvent.isPlayable || !expandedEvent.isInOffer">
        <div class="text" *ngIf="expandedEvent.status !== eventStatusEnum.Finished" i18n="No Active Bets message@@EventDetailsNoActiveBets">Događaj trenutno nema aktivnih kvota, čeka se na ponudu</div>
        <div class="text" *ngIf="expandedEvent.status === eventStatusEnum.Finished" i18n="Event Finished@@EventFinished">Događaj je završen</div>
        <div class="spinner" *ngIf="expandedEvent.status !== eventStatusEnum.Finished"></div>
      </section>
      <ng-container *ngIf="expandedEvent.status !== eventStatusEnum.Finished && expandedEvent.isPlayable && expandedEvent.isInOffer">
        <ng-container *ngFor="let betTypeGroup of betTypeGroups">
          <div class="bet-menu-item" *ngIf="betTypeGroup.isOnline" [class.active]="betTypeGroup.isSelected"  (click)="selectGroup(betTypeGroup)">{{betTypeGroup.name | lowercase}}</div>
        </ng-container>
      </ng-container>

    </div>

    <div class="bet-types-wrap" *ngIf="selectedBetTypeGroup && expandedEvent.status !== eventStatusEnum.Finished && expandedEvent.isPlayable && expandedEvent.isInOffer">
      <ng-container *ngFor="let betTypeGroupingTemplateItem of selectedBetTypeGroup.betTypeGroupingTemplateItems">
        <!-- mozda setovati index i na exact sbv pa pitati isAnyBetPlayable samo kad je all a za ostale slucajeve pitati da li je bets[index].isPlayable -->
        <article class="single-bet-type-wrap" *ngIf="filteredBetsAndBetTypeShowType[betTypeGroupingTemplateItem.betTypeId] && filteredBetsAndBetTypeShowType[betTypeGroupingTemplateItem.betTypeId].isAnyBetPlayable;">
            <ng-container *ngIf="filteredBetsAndBetTypeShowType[betTypeGroupingTemplateItem.betTypeId]; let betAndBetTypeShowTypeForExpandedEvent;">
              <div class="bet-type-name h6" *ngIf="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.showType == betTypeNameDispayTypeEnum.BetTypeNameHeaderRow
              && betAndBetTypeShowTypeForExpandedEvent.isAnyBetPlayable &&
              betTypeGroupingTemplateItem.sbvSelectionType == SBVSelectionEnum.All"
              title="{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription}}">
                <ng-container *ngIf="expandedEvent.eventType == eventTypeENUM.HeadToHead">{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeName}}</ng-container>
                <ng-container *ngIf="expandedEvent.eventType == eventTypeENUM.Outright">{{betAndBetTypeShowTypeForExpandedEvent.betTypeOutrightName}}</ng-container>
                <!-- <i *ngIf="viewConfigurations.showBetTypeNameDescription && betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription" title="{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription}}" class="description-icon icon icon-ex-sm s-icon-sporticon-error"></i> -->

                <span class="more-info" *ngIf="viewConfigurations.showBetTypeNameDescription && betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription" attr.titleDes="{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription}}" >
                  <i class="description-icon icon icon-ex-sm s-icon-sporticon-error" (click)="showDescription($event)" (mouseover)="toggleDescription($event)" (mouseout)="toggleDescription($event)"></i>
                  <span class="description-title">{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription}}</span>
                </span>

                <!-- <span class="icon cashout">
                  <div class="sporticon sporticon-transaction icon-sm" title="Casheback" *ngIf="betAndBetTypeShowTypeForExpandedEvent.bets[0] && betAndBetTypeShowTypeForExpandedEvent.bets[0].cashBackEnabled"></div>
                </span> -->
              </div>
              <div class="bets-conatainer bets-in-row-{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.numberOfBetsInRow}}">
                <ng-container *ngFor="let bet of betAndBetTypeShowTypeForExpandedEvent.bets; let i = index;" >
                  <div class="single-bet" *ngIf="
                  bet.isPlayable &&
                  bet.hasPlayableOutcomes &&
                  (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.All ||
                  (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.MostBalanced && betAndBetTypeShowTypeForExpandedEvent.mostBalancedBetIndex == i) ||
                  (betTypeGroupingTemplateItem.sbvSelectionType === SBVSelectionEnum.Exact && bet.sbv === betTypeGroupingTemplateItem.sbvExactValue))">
                    <div class="bet-type-name h6" *ngIf="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.showType == betTypeNameDispayTypeEnum.BetTypeNameSameRow || betTypeGroupingTemplateItem.sbvSelectionType != SBVSelectionEnum.All" title="{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription}}">
                      <ng-container *ngIf="expandedEvent.eventType == eventTypeENUM.HeadToHead">{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeName}}</ng-container>
                      <ng-container *ngIf="expandedEvent.eventType == eventTypeENUM.Outright">{{bet.outrightName}}</ng-container>
                      <span class="sbv" *ngIf="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.sbvDisplayType === SBVDisplayTypeEnum.SBVInBetType">
                        <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                        <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                      </span>
                      <!-- <i *ngIf="viewConfigurations.showBetTypeNameDescription && betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription" title="{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription}}" class="description-icon icon icon-ex-sm s-icon-sporticon-error"></i> -->

                      <span class="more-info" *ngIf="viewConfigurations.showBetTypeNameDescription && betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription">
                        <i class="description-icon icon icon-ex-sm s-icon-sporticon-error" (click)="showDescription($event)" (mouseover)="toggleDescription($event)" (mouseout)="toggleDescription($event)"></i>
                        <span class="description-title">{{betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeDescription}}</span>
                        <!-- <span class="description-title"></span> -->
                      </span>


                      <!-- <span class="icon cashout">
                        <div class="sporticon sporticon-transaction icon-sm" title="Casheback" *ngIf="betAndBetTypeShowTypeForExpandedEvent.bets[0] && betAndBetTypeShowTypeForExpandedEvent.bets[0].cashBackEnabled"></div>
                      </span> -->
                    </div>
                    <div class="bet-outcomes-wrap" [class.two-column]="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList.length == 2" [class.single-column]="betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList.length == 1" >
                      <ng-container *ngFor="let bto of betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeOutcomesList">
                        <!-- <app-event-details-outcome-template
                        [bet]="bet"
                        [betTypeOutcome]= "bto"
                        [betTypeShowType] = "betAndBetTypeShowTypeForExpandedEvent.betTypeShowType"
                        (outcomeClicked)="toggleEventOutcome(bet, $event, bto, betAndBetTypeShowTypeForExpandedEvent.betTypeShowType.betTypeName)"
                        ></app-event-details-outcome-template> -->


                        <ng-container *ngTemplateOutlet="outcome; context:{bet: bet, betTypeOutcome: bto, betTypeShowType: betAndBetTypeShowTypeForExpandedEvent.betTypeShowType}">
                          </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
        </article>
      </ng-container>
    </div>

    <ng-template #outcome let-bet="bet" let-betTypeOutcome="betTypeOutcome" let-betTypeShowType="betTypeShowType">
          <!-- SBV SEPARATE -->
          <ng-container *ngIf="betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVAlone; else sbvInBetTypeOrOutcome;">
            <ng-container *ngIf="bet.betOutcomesDic[betTypeOutcome.id] && bet.betOutcomesDic[betTypeOutcome.id].length > 0; else emptyOutcome;">
              <ng-container *ngFor="let betOutcome of bet.betOutcomesDic[betTypeOutcome.id]; let k = index;">
                <div class="outcome-wrap" title="{{betTypeOutcome.descriptions}}">
                    <div [@blink-border]="betOutcome.odd" class="btn small outline-light outcome" [ngClass]="{'selected': betOutcome.isSelected}"
                    (click)="toggleEventOutcome(bet, betOutcome, betTypeOutcome.name, betTypeShowType.betTypeName)" title="{{betOutcome.description}}">
                      <!-- <ng-container *ngIf="bet.betOutcomesDic[betTypeOutcome.id]; else emptyOutcome;"> -->
                        <span class="outcome-name">{{betOutcome.name}}</span>
                        <span class="odd online-odd" *ngIf="expandedEvent.isPlayable && bet.isPlayable && betOutcome.isPlayable && betOutcome.odd > 1; else lockedOdd">{{betOutcome.odd | odd}}</span>
                        <ng-template #lockedOdd>
                          <span class="odd locked">
                            <i class="icon icon-ex-sm icon-lock"></i>
                            <!-- <app-svg-icon iconId="lock"></app-svg-icon> -->
                          </span>
                        </ng-template>
                      <!-- </ng-container> -->
                      <!-- <ng-template #emptyOutcome>
                        <span class="outcome-name">{{betTypeOutcome.name}}</span>
                        <span class="odd locked">
                            <app-svg-icon iconId="lock"></app-svg-icon>
                        </span>
                      </ng-template> -->
                    </div>
                </div>
                <div class="sbv-wrap" *ngIf="bet.sbv && betTypeOutcome.orderNumber == 1 && k == 0">
                    <div class="btn small outline-info sbv disabled">
                        <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                        <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                    </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #emptyOutcome>
              <div class="outcome-wrap" *ngIf="bet.sbv" title="{{betTypeOutcome.descriptions}}">
                <div class="btn small outline-light outcome disabled">
                  <span class="outcome-name">{{betTypeOutcome.name}}</span>
                  <i class="icon icon-ex-sm icon-lock"></i>
                  <!-- <span class="odd locked">
                    <app-svg-icon iconId="lock"></app-svg-icon>
                  </span> -->
                </div>
              </div>
              <div class="sbv-wrap" *ngIf="bet.sbv && betTypeOutcome.orderNumber == 1">
                <div class="btn small outline-info sbv disabled">
                  <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                  <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #sbvInBetTypeOrOutcome>
            <ng-container  *ngIf="bet.betOutcomesDic[betTypeOutcome.id] && bet.betOutcomesDic[betTypeOutcome.id].length > 0; else emptyOutcome;">
              <ng-container *ngFor="let betOutcome of bet.betOutcomesDic[betTypeOutcome.id]; let k = index;">
                <div class="outcome-wrap" title="{{betTypeOutcome.descriptions}}">
                  <div [@blink-border]="betOutcome.odd" class="btn small outline-light outcome" title="{{betOutcome.description}}"
                    [ngClass]="{'selected': betOutcome.isSelected}"
                    (click)="toggleEventOutcome(bet, betOutcome, betTypeOutcome.name, betTypeShowType.betTypeName)">
                    <!-- <ng-container *ngIf="bet.betOutcomesDic[betTypeOutcome.id]; else emptyOutcome;"> -->
                      <span class="outcome-name">
                        {{betOutcome.name}}
                        <span class="sbv" *ngIf="betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVInOutcome">
                          <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                          <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                        </span>
                      </span>
                      <span class="odd online-odd"  *ngIf="expandedEvent.isPlayable && bet.isPlayable && betOutcome.isPlayable && betOutcome.odd > 1; else lockedOdd">{{betOutcome.odd | odd}}</span>
                      <ng-template #lockedOdd>
                        <span class="odd locked">
                          <i class="icon icon-ex-sm icon-lock"></i>
                          <!-- <app-svg-icon iconId="lock"></app-svg-icon> -->
                        </span>
                      </ng-template>
                    <!-- </ng-container> -->
                    <!-- <ng-template #emptyOutcome>
                      <span class="outcome-name">
                        {{betTypeOutcome.name}}
                        <ng-container *ngIf="bet.sbv && betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVInOutcome">
                          {{bet.sbv}}</ng-container>
                      </span>
                      <span class="odd locked">
                        <app-svg-icon iconId="lock"></app-svg-icon>
                      </span>
                    </ng-template> -->

                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #emptyOutcome>
              <div class="outcome-wrap" *ngIf="bet.sbv">
                <div class="btn small outline-light outcome disabled">
                  <span class="outcome-name">
                    <ng-container *ngIf="betTypeOutcome.desktopShowType == betTypeOutcomeShowTypeEnum.BTOFullName">
                      {{betTypeOutcome.name}}
                    </ng-container>
                    <ng-container *ngIf="betTypeOutcome.desktopShowType == betTypeOutcomeShowTypeEnum.BTOShortName">
                      {{betTypeOutcome.shortName}}
                    </ng-container>
                    <span class="sbv" *ngIf="bet.sbv && betTypeShowType.sbvDisplayType == SBVDisplayTypeEnum.SBVInOutcome">
                      <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                      <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                    </span>
                   </span>
                  <i class="icon icon-ex-sm icon-lock"></i>
                  <!-- <span class="odd locked">
                    <app-svg-icon iconId="lock"></app-svg-icon>
                  </span> -->
                </div>
              </div>
            </ng-template>
          </ng-template>
    </ng-template>

  </section>
</section>
